/* Native before/after slider — width-based reveal. filmis.fun */
(function () {
  function clamp(v, lo, hi) { return Math.min(hi, Math.max(lo, v)); }

  var DUR = 300, EASE = 'ease';

  // Arrows exit OUTWARD + fade on drag; on release they fade in coming FROM the line.
  // Driven via Web Animations API so theme CSS resets can't kill it.
  function animateArrows(slider, out) {
    var r = slider.querySelector('.baf-arrow-r > svg');
    var l = slider.querySelector('.baf-arrow-l > svg');
    var opt = { duration: DUR, easing: EASE, fill: 'forwards' };
    if (r) {
      if (r._baf) r._baf.cancel();
      r._baf = r.animate(out
        ? [{ opacity: 1, transform: 'translateX(0)' }, { opacity: 0, transform: 'translateX(100%)' }]
        : [{ opacity: 0, transform: 'translateX(-100%)' }, { opacity: 1, transform: 'translateX(0)' }], opt);
    }
    if (l) {
      if (l._baf) l._baf.cancel();
      l._baf = l.animate(out
        ? [{ opacity: 1, transform: 'rotate(180deg) translateX(0)' }, { opacity: 0, transform: 'rotate(180deg) translateX(100%)' }]
        : [{ opacity: 0, transform: 'rotate(180deg) translateX(-100%)' }, { opacity: 1, transform: 'rotate(180deg) translateX(0)' }], opt);
    }
  }

  function setWidth(slider) {
    var w = slider.clientWidth;
    slider.style.setProperty('--baf-w', w + 'px');
    setPos(slider, slider._bafPct == null ? 50 : slider._bafPct);
  }

  function setPos(slider, pct) {
    pct = clamp(pct, 0, 100);
    slider._bafPct = pct;
    var w = slider.clientWidth;
    slider.style.setProperty('--baf-pos', pct + '%');           // image reveal (width)
    slider.style.setProperty('--baf-x', (pct / 100 * w) + 'px'); // handle (compositor transform)
    slider.setAttribute('aria-valuenow', Math.round(pct));
  }

  function pctFromEvent(slider, clientX) {
    var r = slider.getBoundingClientRect();
    return ((clientX - r.left) / r.width) * 100;
  }

  function init(slider) {
    if (slider.dataset.bafInit) return;
    slider.dataset.bafInit = '1';

    var start = parseFloat(slider.getAttribute('data-start'));
    slider._bafPct = isNaN(start) ? 50 : start;
    setWidth(slider);

    // keyboard control (slider is the accessible element; no native input)
    slider.addEventListener('keydown', function (e) {
      var cur = slider._bafPct == null ? 50 : slider._bafPct;
      var step = e.shiftKey ? 10 : 2;
      if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') { setPos(slider, cur - step); e.preventDefault(); }
      else if (e.key === 'ArrowRight' || e.key === 'ArrowUp') { setPos(slider, cur + step); e.preventDefault(); }
      else if (e.key === 'Home') { setPos(slider, 0); e.preventDefault(); }
      else if (e.key === 'End') { setPos(slider, 100); e.preventDefault(); }
    });

    var dragging = false;
    function down(e) {
      dragging = true;
      animateArrows(slider, true);   // slide out + fade
      var x = e.touches ? e.touches[0].clientX : e.clientX;
      setPos(slider, pctFromEvent(slider, x));
    }
    function move(e) {
      if (!dragging) return;
      var x = e.touches ? e.touches[0].clientX : e.clientX;
      setPos(slider, pctFromEvent(slider, x));
    }
    function up() {
      if (!dragging) return;
      dragging = false;
      animateArrows(slider, false);  // fade in from the line
    }

    slider.addEventListener('mousedown', down);
    window.addEventListener('mousemove', move);
    window.addEventListener('mouseup', up);
    slider.addEventListener('touchstart', down, { passive: true });
    slider.addEventListener('touchmove', move, { passive: true });
    slider.addEventListener('touchend', up);

    // keep the before image full-width if the slider is resized
    if (window.ResizeObserver) {
      new ResizeObserver(function () { setWidth(slider); }).observe(slider);
    } else {
      window.addEventListener('resize', function () { setWidth(slider); });
    }
  }

  function initAll(root) {
    (root || document).querySelectorAll('.baf-slider').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
